<template>
  <!-- FOOTER -->
  <Container
    use-full-width
    tag="footer"
    class="flex flex-col justify-between gap-y-12 overflow-hidden bg-secondary-900 text-white"
  >
    <div class="flex w-full gap-x-8">
      <!-- SWISS FLAG FOR MD+ -->
      <IconWetrokSwissVertical class="hidden h-36 w-min shrink-0 2xl:-ml-12 2xl:flex md:flex md:h-48" />

      <!-- MAIN FOOTER CONTENT -->
      <div
        fix
        class="flex w-full flex-col gap-y-8 pt-12 md:flex-row md:flex-wrap md:items-baseline md:pt-[5.7rem]"
      >
        <!-- LINE -->
        <div class="flex w-full flex-col font-semibold 2xl:w-auto 2xl:basis-1/2">
          <div class="inline-block typo-h2 lg:whitespace-nowrap">
            {{ data?.footer_heading }}
          </div>
          <div class="inline-block typo-h3 lg:whitespace-nowrap">
            {{ data?.footer_sub_heading }}
          </div>
        </div>

        <!-- CONTACT -->
        <div class="flex basis-1/2 justify-between typo-subtitle 2xl:basis-1/4">
          <div class="flex flex-col gap-y-5">
            <div class="leading-6" v-html="data?.address" />
            <div v-for="contact_option in data?.contact_options" :key="contact_option.id">
              <span v-if="contact_option.label" class="leading-6">{{ contact_option.label }}</span>
              <NuxtLink
                v-if="contact_option.phone"
                :to="`tel:${contact_option.phone}`"
                class="block w-max leading-6"
              >
                {{ contact_option.phone }}
              </NuxtLink>
              <NuxtLink
                v-if="contact_option.email"
                :to="`mailto:${contact_option.email}`"
                class="block w-max leading-6"
              >
                {{ contact_option.email }}
              </NuxtLink>
            </div>
          </div>

          <IconWetrokSwissHorizontal class="-mr-24 h-24 md:hidden sm:-mr-12" />
        </div>

        <!-- FOOTER LINKS -->
        <ul class="basis-1/2 2xl:basis-1/4">
          <template v-for=" link in data?.footer_links" :key="link.id">
            <li v-if="link.link && link.link_text">
              <NuxtLink

                :to="link.link"
                class="
                  flex w-full items-center justify-between border-b border-white pb-2 pt-6 typo-lead
                  hover:opacity-75
                "
              >
                <span class="overflow-hidden text-ellipsis pr-2">{{ link.link_text }}</span>
                <IconArrowUpRight class="size-8 shrink-0" />
              </NuxtLink>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <!-- FOOTER BOTTOM -->
    <div class="flex flex-col gap-6 pb-8 md:flex-row md:items-center md:justify-between">
      <!-- META NAVIGATION -->
      <ul class="flex flex-wrap gap-x-6 gap-y-4 typo-subtitle">
        <li v-for="{ page } in globals?.footer.tree" :key="page.id" class="">
          <NuxtLink :to="page.url">
            {{ page.title }}
          </NuxtLink>
        </li>
        <li>
          <button
            type="button"
            @click="() => $cookieconsent.showPreferences()"
          >
            {{ $t('cookie_consent.button_text_show_preferences') }}
          </button>
        </li>
      </ul>

      <!-- SOCIAL MEDIA -->
      <ul class="flex gap-2">
        <li v-for="item in data?.social_media_channels" :key="item.id">
          <AppButton :to="item.link" variant="secondary" inverted>
            <template #icon>
              <IconLinkedin
                v-if="item.channel.value === 'linkedin'"
                class="size-7"
              />
              <IconYoutube v-else-if="item.channel.value === 'youtube'" class="size-7" />
            </template>
          </AppButton>
        </li>
      </ul>
    </div>
  </Container>
</template>

<script lang="ts" setup>
const globals = inject(GlobalsKey, null)

const data = computed(() => globals?.value.general)
</script>
